import React from 'react';
import './Community.css';

export default function Community() {
  return (
    <section id="community" className="community">
      <div className="comm-bar">
        <span className="comm-label">// community/cncf-jordan</span>
      </div>
      <div className="comm-body">
        <div className="comm-stats">
          <div className="comm-stat"><div className="cs-n">CNCF</div><div className="cs-l">chapter organizer</div></div>
          <div className="comm-stat"><div className="cs-n">JO</div><div className="cs-l">Jordan chapter</div></div>
          <div className="comm-stat"><div className="cs-n">K8s</div><div className="cs-l">core focus</div></div>
          <div className="comm-stat"><div className="cs-n">2025</div><div className="cs-l">founded</div></div>
        </div>
        <p className="comm-desc">
          I run the CNCF Jordan Chapter — meetups, workshops and honest conversations
          about Kubernetes, GitOps and what modern DevOps looks like in practice.
          Helping engineers in Jordan go further together.
        </p>
      </div>
    </section>
  );
}
